import { css } from "@emotion/css"
import React, { useCallback } from "react"

import COLOR_CODE from "../../../constant/color"
import Question from "../icon/Question/Question"

type Props = {
  isShow?: boolean
  helpURL?: string
  children: React.ReactNode
}

const CourseOptionContainer = ({ isShow, helpURL, children }: Props) => {
  const open = useCallback(() => {
    window.open(helpURL, "_blank")
  }, [helpURL])

  if (!isShow) {
    return null
  }

  return (
    <div className={style}>
      {children}
      {helpURL && (
        <div className={help}>
          <Question onClick={open} />
        </div>
      )}
    </div>
  )
}

const help = css`
  display: flex;
  align-items: center;
  padding-left: 8px;

  > * {
    z-index: 2;
  }
`

const style = css`
  display: flex;
  align-items: center;
  height: 26px;
  padding: 3px 3px 4px;
  line-height: 1;

  input:not(:checked) + & {
    > span:not(:first-child) {
      color: ${COLOR_CODE.LIGHT_GRAY};
    }
  }
`

export default CourseOptionContainer
